module.exports = __webpack_public_path__ + "static/media/2.b92b2889.svg";